import "../../css/pages/cnc.scss";
import BasePage from "./base";
import band from "../modules/band";
import map from "../modules/map.js";
import { setScrollLink } from "../modules/scrollTo";

class CNC extends BasePage {
    constructor(...opts) {
        super(...opts);
    }

    init() {
        super.init();
    }

    onReady() {
        super.onReady();
        map.init();
        setScrollLink(".button");

        const images = document.querySelectorAll(".pageHero__bgSlideImage");

        if (images.length !== 0) {
            const max = images.length - 1;
            images[0].classList.add("pageHero__bgSlideImage--show");

            let keySlide = 1;
            setInterval(() => {
                images.forEach(el => {
                    el.style.opacity = 0;

                    setTimeout(() => {
                        el.classList.remove("pageHero__bgSlideImage--show");
                    }, 500);
                });

                setTimeout(() => {
                    images[keySlide].classList.add("pageHero__bgSlideImage--show");

                    setTimeout(() => {
                        images[keySlide].style.opacity = 1;
                    }, 50);
                }, 500);

                if (keySlide < max) {
                    keySlide++;
                } else {
                    keySlide = 0;
                }
            }, 7e3);
        }
    }

    onLoad() {
        super.onLoad();
        if (window.innerWidth < 768) {
            document.querySelectorAll(".anim").forEach(el => {
                const preset = el.dataset.animPreset;
                el.classList.remove(`band--${preset}`);
            });
        } else {
            band.init();
        }
    }
}

new CNC();
